import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Constants } from 'src/app/common/constants';
import { SeoService } from 'src/app/common/seo.service';
import * as AOS from 'aos';

@Component({
  selector: 'app-staffing-process',
  templateUrl: './staffing-process.component.html',
  styleUrl: './staffing-process.component.css'
})
export class StaffingProcessComponent {
 baseUrl = Constants.baseUrl;
    isBrowser:boolean=false;
    constructor( private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private seoService:SeoService,
    private metaService: Meta) {this.isBrowser=isPlatformBrowser(this.platformId);}
    ngOnInit(): void {
      this.seoService.createLinkForCanonicalURL();
      this.setTitleAndMetaTags();
      let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/staffing-process/"
    },
    "headline": "IT Staffing Company | IT Recruitment Agency | Maganti IT Resource",
    "description": "Maganti IT Resource is a trusted IT staffing company and recruitment agency delivering skilled tech professionals to businesses of all sizes. Fast hiring, flexible models, and quality talent guaranteed.",
    "image": "https://mitresource.com/assets/images/staffing-process/image (3).jpeg",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2024-10-28"
  }
  `;
    this._renderer2.appendChild(this._document.body, script);
      if(this.isBrowser){     
        AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
        AOS.init({
          once: true, 
        });
      }
      this.setTitleAndMetaTags();
      this.seoService.createLinkForCanonicalURL();
    }
    private setTitleAndMetaTags(): void {
      this.titleService.setTitle('IT Staffing Company | IT Recruitment Agency | Maganti IT Resource');
      this.metaService.addTags([
        { name: 'description', content: 'Maganti IT Resource is a trusted IT staffing company and recruitment agency delivering skilled tech professionals to businesses of all sizes. Fast hiring, flexible models, and quality talent guaranteed.' },
        { property: 'og:type', content: 'website' },
        { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
        { property: 'og:title', content: 'IT Staffing Company | IT Recruitment Agency | Maganti IT Resource' },
        { property: 'og:url', content: 'https://mitresource.com/staffing-process/' },
        { property: 'og:image', content: 'https://mitresource.com/assets/images/staffing-process/image (3).jpeg' },
        { property: 'og:description', content: 'Partner with Maganti IT Resource for reliable IT staffing and recruitment services. We connect businesses with top tech talent through flexible hiring models.' },
      ]);
    }
  faqs = [
    { question: 'How quickly can you deliver candidates?', answer: ' We typically deliver the first shortlist of qualified, pre-screened candidates within 24–48 hours of receiving the job requirement.', open: false },
    { question: 'What is your vetting process for candidates?', answer: 'Our screening includes eligibility verification, technical and soft skill assessments, background checks, and client-specific onboarding steps to ensure a strong match. ', open: false },
    { question: 'How do you handle onboarding?', answer: 'We assess for communication style, time zone compatibility, and team dynamics to ensure each hire integrates smoothly into your environment. ', open: false },
    { question: 'What happens if a consultant isn’t the right fit?', answer: 'We offer a no-cost replacement within a defined guarantee period and act quickly to find the right match.', open: false },
    { question: 'Can we interview the candidates you submit?', answer: 'candidates directly or allow us to manage the entire hiring process on your behalf. ', open: false },
    { question: 'Do you support remote, hybrid, and on-site models?', answer: ' Yes. Our talent pool supports fully remote, hybrid, and on-site staffing requirements based on your project needs. ', open: false },
    { question: 'How do you ensure cultural fit and communication alignment?', answer: ' We coordinate onboarding with your team—ensuring clarity on roles, access to tools, and cultural integration for a seamless start. ', open: false }
  ];

  toggle(index: number): void {
    this.faqs[index].open = !this.faqs[index].open;
  }
  hover = false;
  hover1=false;
  hover2=false;
  hover3=false;
  hover4=false;
  hover5=false;
  hover6=false;
  hover7=false;
  hover8=false;

  scrollToSection(sectionId: string) {
    if(this.isBrowser){
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

}
